import Sd from "../../widget/CandidatePage/Sd/Sd";

export const SdPage = () => {
    return <Sd />;
};
